import React, { useEffect, useState } from 'react';
import { Container } from 'aurelia-framework';
import { ColumnLoader } from '../../../object-display/column-loader';
import getPropertyByPath from '../../../utilities/get-property-by-path';
import { useAureliaI18n } from '../../../react-hooks/useAureliaI18n';
import { getFieldRenderer } from './getCellRenderer';
import Popover from './helpers/Popover';

const getColumnClass = (column) => {
    if (column.type === 'money' || column.type === 'number') {
        return 'tw-text-right';
    }
    return '';
};

const CellTable = ({ params, field }) => {
    const value = params?.value;
    const [columns, setColumns] = useState([]);
    const { t } = useAureliaI18n();

    useEffect(() => {
        const columnLoader = Container.instance.get(ColumnLoader);
        columnLoader
            .loadColumns(
                { modelId: field?.options?.modelId },
                (field?.options?.columns ?? []).map((entry) => entry.property)
            )
            .then(setColumns);
    }, [field?.options?.modelId, field?.options?.columns]);

    return (
        <table className="tw-relative tw-w-full tw-divide-y tw-divide-gray-300 embed-table">
            <thead>
                <tr>
                    {columns.map((column) => (
                        <th
                            key={column.property}
                            className={`tw-py-2.5 tw-pr-3 tw-pl-4 tw-text-left tw-text-sm tw-hyphens-auto tw-font-semibold tw-text-gray-900 sm:tw-pl-0 ${getColumnClass(column)}`}
                            scope="col"
                        >
                            {t(column.label)}
                            {column.help && column.help !== '' && (
                                <Popover content={column.help} />
                            )}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody className="tw-divide-y tw-divide-gray-200 tw-bg-white">
                {value?.length > 0 ? (
                    value.map((item, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((column) => {
                                const cellValue = getPropertyByPath(item, column.property);
                                return (
                                    <td
                                        key={column.property}
                                        className={`tw-py-2 tw-pr-3 tw-pl-4 tw-text-sm tw-text-gray-900 tw-hyphens-auto sm:tw-pl-0 ${getColumnClass(column)}`}
                                        style={{ wordBreak: 'break-word' }}
                                    >
                                        {getFieldRenderer(column)({
                                            value: cellValue,
                                            row: item,
                                            rowIndex,
                                        })}
                                    </td>
                                );
                            })}
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td
                            colSpan={columns.length || 1}
                            className="tw-py-2 tw-text-center tw-text-sm tw-text-gray-900"
                        >
                            {t('list.no_records_found')}
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default CellTable;
